import React, { useState } from 'react';
import { Button, Form, Modal } from 'antd';
import { observer } from 'mobx-react';
import useStore from '../../../../store';
import { Notification } from '../../../../config/Global';
import EnquiryForm from './FormComponent';

const AddComponent = observer((props) => {
	const { visible, onClose } = props;

	const [form] = Form.useForm();

	const { ENQUIRY } = useStore();

	const [disabled, setDisabled] = useState(true);
	const [saving, setSaving] = useState(false);

	const handleSubmit = async (data) => {
		setSaving(true);

		try {
			const response = await ENQUIRY.addEnquiry({
				...data,
			});

			if (response.httpStatusCode === 200) {
				Notification.success({
					message: 'Enquiry Added Successfully!',
				});
			}

			closeModal();
		} catch (error) {
			Notification.error({
				message: 'Error Adding Enquiry!',
			});
		} finally {
			setSaving(false);
		}
	};

	const handleChange = async () => {
		form.validateFields({ validateOnly: true })
			.then(() => {
				setDisabled(false);
			})
			.catch(() => {
				setDisabled(true);
			});
	};

	const closeModal = () => {
		setDisabled(true);
		form.resetFields();
		onClose();
	};

	return (
		<Modal
			title="Add Enquiry"
			onCancel={closeModal}
			open={visible}
			destroyOnClose
			width={'900px'}
			footer={
				<div>
					<Button
						type="primary"
						key={1}
						disabled={disabled}
						htmlType="submit"
						loading={saving}
						form="AddEnquiryForm"
					>
						Add Enquiry
					</Button>

					<Button key={2} onClick={closeModal}>
						Cancel
					</Button>
				</div>
			}
		>
			<EnquiryForm
				id="AddEnquiryForm"
				form={form}
				onFinish={handleSubmit}
				handleChange={handleChange}
			/>
		</Modal>
	);
});

export default AddComponent;